// removed by extract-text-webpack-plugin
module.exports = {"Error":"error__Error__2xMuU","kf_shake":"error__kf_shake__3E5og","FullPageError":"error__FullPageError__k1ghk error__Error__2xMuU"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/HOC/error.css
// module id = 913
// module chunks = 2